/* 🎼 IAS CHORD ENGINE — shared tone + chord core for the Chord Builder page and the
   homepage key tiles (Deck orders 10-12, build-once-use-twice).
   EAR LAW (Deck ruling 10-12): synthetic tones are OFF by default — window.IAS_TONES_ON
   must be set true (founder unlock) before tone()/chord() make any sound. A sound brand
   plays nothing fake; real founder-verified clips ride per tile regardless.
   MODE-PAIRED: discount math reads assets/ias-rates.json's ACTIVE mode (cfg[cfg.mode]);
   this file never hand-types a percentage. Window-honest like ias-ladder.js: event tiers
   outside the window return empty (?ias-ladder-preview=1 forces for QA).
   Fails closed everywhere. */
(function () {
  'use strict';
  if (window.IASChordEngine) return;
  var ctx = null, base = 432;
  function ensureCtx() { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); return ctx; }
  function freq(midi) { return base * Math.pow(2, (midi - 69) / 12); }
  function tone(midi, t0, dur) {
    if (!window.IAS_TONES_ON) return;   // Deck ruling 10-12: no synthetic tones on a sound brand — founder clips unlock this
    try {
      var c = ensureCtx(), o = c.createOscillator(), g = c.createGain();
      var t = c.currentTime + (t0 || 0); dur = dur || 1.05;
      o.type = 'sine'; o.frequency.value = freq(midi);
      o.connect(g); g.connect(c.destination);
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.2, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.start(t); o.stop(t + dur + 0.05);
    } catch (e) {}
  }
  function chord(midis) { (midis || []).forEach(function (m, i) { tone(m, i * 0.07, 1.6); }); }

  var rates = null, ratesLoad = null;
  function loadRates() {
    if (ratesLoad) return ratesLoad;
    var u = window.IAS_RATES_URL;
    ratesLoad = (u ? fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }) : Promise.resolve(null))
      .then(function (c) { rates = c; return c; }).catch(function () { return null; });
    return ratesLoad;
  }
  function activeTiers(cfg) {
    if (!cfg || cfg.mode === 'off') return [];
    if (cfg.mode === 'event' && !/[?&]ias-ladder-preview=1/.test(location.search)) {
      var w = cfg.window || {}, n = Date.now();
      if (w.starts_at && n < Date.parse(w.starts_at)) return [];
      if (w.ends_at && n > Date.parse(w.ends_at)) return [];
    }
    return (cfg[cfg.mode] || {}).tiers || [];
  }
  function tierFor(cfg, keys) {
    var t = null;
    activeTiers(cfg).forEach(function (x) { if (keys >= x.min_keys && (!t || x.min_keys > t.min_keys)) t = x; });
    return t;
  }

  window.IASChordEngine = {
    setBase: function (hz) { base = parseInt(hz, 10) || 432; },
    getBase: function () { return base; },
    tone: tone, chord: chord,
    loadRates: loadRates, tierFor: tierFor, activeTiers: activeTiers,
    freeShip: function () { return rates && rates.free_ship_threshold ? rates.free_ship_threshold * 100 : 20000; },
    money: function (cents) { var n = cents / 100; return (window.IAS_SYM || '$') + (n % 1 ? n.toFixed(2) : n.toFixed(0)); },
    tiles: function () { return Array.prototype.slice.call(document.querySelectorAll('[data-ias-tile]')); },
    tileByMidi: function (m) { return document.querySelector('[data-ias-tile][data-midi="' + m + '"]'); },
    highlight: function (midis) {
      var set = {}; (midis || []).forEach(function (m, i) { set[m] = i; });
      var ROLES = ['ROOT', 'THIRD', 'FIFTH', 'VOICE'];
      this.tiles().forEach(function (el) {
        var m = parseInt(el.dataset.midi, 10);
        var on = Object.prototype.hasOwnProperty.call(set, m);
        el.classList.toggle('ias-tile--lit', on);
        el.classList.toggle('ias-tile--root', on && set[m] === 0);
        if (on) el.setAttribute('data-ias-role', ROLES[set[m]] || 'VOICE');
        else el.removeAttribute('data-ias-role');
      });
    },
    clear: function () { this.highlight([]); }
  };
})();